import { useMemo } from 'react';
import { LogLevel } from "@azure/msal-browser";

const UseAuthConfig = () => {

  const b2cPolicies = {
    names: {
      signUpSignIn: process.env.REACT_APP_B2C_SIGN_IN_NAME,
      forgotPassword: process.env.REACT_APP_B2C_PASSWORD_RESET_NAME,
      editProfile: process.env.REACT_APP_B2C_PROFILE_EDIT_NAME,
    },
    authorities: {
      signUpSignIn: {
        authority: process.env.REACT_APP_B2C_SIGN_IN_AUTHORITY,
      },
      forgotPassword: {
        authority: process.env.REACT_APP_B2C_PASSWORD_RESET_AUTHORITY,
      },
      editProfile: {
        authority: process.env.REACT_APP_B2C_PROFILE_EDIT_AUTHORITY,
      },
    },
    authorityDomain: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN,
  };

  const protectedResources = {
    apiTodoList: {
      endpoint: process.env.REACT_APP_API_TODO_LIST_ENDPOINT,
      scopes: {
        read: [process.env.REACT_APP_API_TODO_LIST_READ_SCOPE],
        write: [process.env.REACT_APP_API_TODO_LIST_WRITE_SCOPE],
      },
    },
}

  const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
      authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
      knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
      redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
      postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl:false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: process.env.REACT_APP_MSAL_CACHE_LOCATION, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: any, message: any, containsPii: any) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              // console.info(message);
              return;
            case LogLevel.Verbose:
              // console.debug(message);
              return;
            case LogLevel.Warning:
              // console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  };

  const loginRequest : any = {
    scopes: [
      ...protectedResources.apiTodoList.scopes.read,
      ...protectedResources.apiTodoList.scopes.write,
    ],
  };
  return {  protectedResources, b2cPolicies, msalConfig, loginRequest };
};

export default UseAuthConfig;
